import React from 'react'

import { COLORS } from '@btime/constants'
import Container from '../../../../components/structure/Container'

const styles = {
  root: {
    backgroundColor: COLORS.light3,
    padding: '3rem',
    position: 'relative'
  },

  content: {
    backgroundColor: COLORS.white,
    borderRadius: '5px',
    padding: '1cm',
    minWidth: '29.7cm',
    minHeight: '21cm',
    overflow: 'hidden'
  }
}

const LandscapePreview = ({ children }) => (
  <div style={styles.root}>
    <Container maxWidth="29.7cm">
      <div style={styles.content}>{children}</div>
    </Container>
  </div>
)

export default LandscapePreview
